/*
 * @Description: 日程管理 - 嘉宾API
 * @Author: AI Assistant
 * @Date: 2023-10-30
 */

import request from '@/utils/request'

/**
 * 获取嘉宾列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getGuestList(params) {
  return request({
    url: '/guest/list',
    method: 'get',
    params
  })
}

/**
 * 添加嘉宾
 * @param {Object} data - 嘉宾数据
 * @returns {Promise}
 */
export function addGuest(data) {
  return request({
    url: '/guest/add',
    method: 'post',
    data
  })
}

/**
 * 编辑嘉宾
 * @param {Object} data - 嘉宾数据
 * @returns {Promise}
 */
export function editGuest(data) {
  return request({
    url: '/guest/edit',
    method: 'post',
    data
  })
}

/**
 * 删除嘉宾
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function deleteGuest(data) {
  return request({
    url: '/guest/delete',
    method: 'post',
    data
  })
}

/**
 * 获取嘉宾详情
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function getGuestDetail(data) {
  return request({
    url: '/guest/detail',
    method: 'post',
    data
  })
}

/**
 * 批量删除嘉宾
 * @param {Object} data - 包含ids数组的对象
 * @returns {Promise}
 */
export function batchDeleteGuests(data) {
  return request({
    url: '/guest/batchDelete',
    method: 'post',
    data
  })
}

/**
 * 更新嘉宾排序
 * @param {Object} data - 包含guestsSort数组的对象
 * @returns {Promise}
 */
export function updateGuestSort(data) {
  return request({
    url: '/guest/updateSort',
    method: 'post',
    data
  })
}

/**
 * 获取嘉宾分组列表
 * @returns {Promise}
 */
export function getGuestCategories() {
  return request({
    url: '/guest/categories',
    method: 'get'
  })
}

/**
 * 添加嘉宾分组
 * @param {Object} data - 分组数据
 * @returns {Promise}
 */
export function addGuestCategory(data) {
  return request({
    url: '/guest/category/add',
    method: 'post',
    data
  })
}

/**
 * 编辑嘉宾分组
 * @param {Object} data - 分组数据
 * @returns {Promise}
 */
export function editGuestCategory(data) {
  return request({
    url: '/guest/category/edit',
    method: 'post',
    data
  })
}

/**
 * 删除嘉宾分组
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function deleteGuestCategory(data) {
  return request({
    url: '/guest/category/delete',
    method: 'post',
    data
  })
} 